(function () {
  document.addEventListener('click', e => {
    const el = e.target.closest('[data-dl-menu-click]');
    if (!el) return;
    window.app?.dl.menuClick(el.dataset.dlText || el.textContent.trim(), {
      link_classes: el.dataset.dlClasses || 'text',
      ...(el.dataset.dlId && { link_id: el.dataset.dlId })
    });
  });

  function trackMenuHover(text) {
    window.app?.dl.menuHover(text);
  }

  function initHeader(container) {
  const body = document.querySelector('body');
  const sections = container.querySelectorAll('.header');
  if (!sections.length) return;
  const announcementBar = document.querySelector('.mt-announcement-bar-section');

  const getStickyOffset = () => announcementBar ? announcementBar.clientHeight : 0;

  sections.forEach(section => {
    if (section.dataset.hv2Init) return;
    section.dataset.hv2Init = 'true';

    const wrapper = section.closest('.header-wrapper');

    const updateHeaderOffsets = () => {
      const offset = Math.max(Math.round(section.getBoundingClientRect().bottom), 0);
      (wrapper || section).style.setProperty('--hv2-header-bottom', offset + 'px');
    };
    const headerOffsetObserver = new ResizeObserver(updateHeaderOffsets);
    headerOffsetObserver.observe(section);
    if (announcementBar) headerOffsetObserver.observe(announcementBar);

    const stickyHeader = () => {
      if (window.scrollY > getStickyOffset()) {
        section.classList.add('header--sticky');
        wrapper?.classList.add('sticky');
      } else {
        section.classList.remove('header--sticky');
        wrapper?.classList.remove('sticky');
      }
      updateHeaderOffsets();
    };
    stickyHeader();
    window.addEventListener('scroll', stickyHeader);
    window.addEventListener('resize', stickyHeader);

    const navItems = section.querySelectorAll('.header__nav-item--dropdown');
    if (navItems.length) {
      let openCount = 0;
      const updateAnyOpen = delta => {
        openCount = Math.max(openCount + delta, 0);
        body.classList.toggle('header-mm-open', openCount > 0);
      };

      const syncStates = new Map();
      const forceClose = (item, panel) => {
        panel.hidden = true;
        syncStates.get(item)?.();
        const reopen = () => { panel.hidden = false; };
        item.addEventListener('mouseleave', reopen, { once: true });
        item.addEventListener('focusout', reopen, { once: true });
      };

      navItems.forEach(item => {
        const link = item.querySelector('.header__nav-link');
        const panel = item.querySelector('.header-mm');
        if (!link || !panel) return;

        let isOpen = false;
        const syncState = () => {
          const open = item.matches(':hover, :focus-within') && !panel.hidden;
          if (open === isOpen) return;
          isOpen = open;
          updateAnyOpen(open ? 1 : -1);
          link.setAttribute('aria-expanded', String(open));
          if (open) trackMenuHover(link.querySelector('span')?.textContent.trim() || link.textContent.trim());
        };
        syncStates.set(item, syncState);

        item.addEventListener('mouseenter', syncState);
        item.addEventListener('mouseleave', syncState);
        item.addEventListener('focusin', syncState);
        item.addEventListener('focusout', syncState);

        const href = link.getAttribute('href');
        if (!href || href === '#') {
          link.addEventListener('click', e => e.preventDefault());
        }
      });

      document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        navItems.forEach(item => {
          if (!item.matches(':hover, :focus-within')) return;
          const panel = item.querySelector('.header-mm');
          const link = item.querySelector('.header__nav-link');
          if (panel) forceClose(item, panel);
          link?.focus();
        });
      });

      section.querySelectorAll('.header-mm__tabs').forEach(tabsEl => {
        const tabs = Array.from(tabsEl.querySelectorAll('.header-mm__tab'));
        const tabsBody = tabsEl.closest('.header-mm__body');
        const panels = tabsBody?.querySelectorAll('.header-mm__tab-panel');
        if (!panels) return;

        const activate = tab => {
          tabs.forEach(t => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          tab.setAttribute('tabindex', '0');

          panels.forEach(panel => {
            panel.classList.toggle('is-active', panel.dataset.tabPanel === tab.dataset.tabTarget);
          });
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('mouseenter', () => activate(tab));
          tab.addEventListener('focus', () => activate(tab));
          tab.addEventListener('click', e => {
            const href = tab.getAttribute('href');
            if (!href || href === '#') e.preventDefault();
          });
          tab.addEventListener('keydown', e => {
            let nextIndex;
            if (e.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
            else if (e.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
            else if (e.key === 'Home') nextIndex = 0;
            else if (e.key === 'End') nextIndex = tabs.length - 1;
            else return;

            e.preventDefault();
            activate(tabs[nextIndex]);
            tabs[nextIndex].focus();
          });
        });
      });

      section.querySelectorAll('.header-mm a[href="#chat"]').forEach(link => {
        link.addEventListener('click', () => {
          const item = link.closest('.header__nav-item--dropdown');
          const panel = item?.querySelector('.header-mm');
          if (item && panel) forceClose(item, panel);
        });
      });
    }

    const toggle = section.querySelector('.header__mobile-toggle');
    const drawer = (wrapper || section).querySelector('.header-mobile');
    if (!toggle || !drawer) return;

    const screens = drawer.querySelectorAll('.header-mobile__screen');
    const rootScreen = drawer.querySelector('[data-screen="root"]');
    let activeScreen = rootScreen;

    const getFocusable = scope => Array.from(
      scope.querySelectorAll('a[href], button:not([disabled])')
    );

    const setActiveScreen = (nextScreen, { focusTarget } = {}) => {
      screens.forEach(s => {
        s.classList.remove('is-active', 'is-prev');
        s.inert = true;
      });

      drawer.querySelectorAll('[data-open-screen]').forEach(btn => {
        btn.setAttribute('aria-expanded', String(btn.dataset.openScreen === nextScreen.dataset.screen));
      });

      if (nextScreen === rootScreen) {
        rootScreen.classList.add('is-active');
        rootScreen.inert = false;
      } else {
        rootScreen.classList.add('is-prev');
        rootScreen.inert = true;
        nextScreen.classList.add('is-active');
        nextScreen.inert = false;
      }

      activeScreen = nextScreen;
      (focusTarget || nextScreen.querySelector('.header-mobile__back') || getFocusable(nextScreen)[0])?.focus();
    };

    drawer.querySelectorAll('[data-open-screen]').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = drawer.querySelector(`[data-screen="${btn.dataset.openScreen}"]`);
        if (target) setActiveScreen(target);
        const text = btn.closest('.header-mobile__link')?.querySelector('.header-mobile__link-label')?.textContent.trim();
        if (text) trackMenuHover(text);
      });
    });

    drawer.querySelectorAll('[data-close-screen]').forEach(btn => {
      const openerHandle = btn.closest('[data-screen]')?.dataset.screen;
      const opener = openerHandle ? section.querySelector(`[data-open-screen="${openerHandle}"]`) : null;
      btn.addEventListener('click', () => setActiveScreen(rootScreen, { focusTarget: opener }));
    });

    drawer.querySelectorAll('[data-accordion-toggle]').forEach(btn => {
      const panel = drawer.querySelector('#HeaderAcc-' + btn.dataset.accordionToggle);
      if (!panel) return;
      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
        if (isOpen) return;
        const text = btn.querySelector('span')?.textContent.trim();
        if (text) trackMenuHover(text);
      });
    });

    const close = ({ restoreFocus = true } = {}) => {
      body.removeAttribute('data-header-active');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.inert = true;
      if (restoreFocus) toggle.focus();
    };

    const open = () => {
      body.setAttribute('data-header-active', true);
      toggle.setAttribute('aria-expanded', 'true');
      drawer.inert = false;
      setActiveScreen(rootScreen, { focusTarget: toggle });
      window.app?.dl.menuOpen();
    };

    toggle.addEventListener('click', () => {
      if (body.hasAttribute('data-header-active')) {
        close({ restoreFocus: false });
      } else {
        open();
      }
    });

    drawer.querySelectorAll('a[href="#chat"]').forEach(link => {
      link.addEventListener('click', () => close({ restoreFocus: false }));
    });

    document.addEventListener('keydown', e => {
      if (!body.hasAttribute('data-header-active')) return;

      if (e.key === 'Escape') {
        close();
        return;
      }

      if (e.key === 'Tab') {
        const focusable = getFocusable(activeScreen);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1130 && body.hasAttribute('data-header-active')) close({ restoreFocus: false });
    });
  });
  }

  initHeader(document);
  document.addEventListener('shopify:section:load', event => initHeader(event.target));
})();
